var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 23.6665H5.95344V9.14111H1V23.6665Z",
    stroke: "#00A862",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95328 11.6708H7.57985C8.68442 11.6708 9.57985 10.7753 9.57985 9.67077V4.22994C9.57985 2.99931 10.5758 2 11.8057 2C13.034 2 14.0299 2.99931 14.0299 4.22994V8.16101C14.0299 9.26558 14.9254 10.161 16.0299 10.161H24.9974C26.1041 10.161 27 11.0601 27 12.1658C27 13.2746 26.1041 14.1721 24.9974 14.1721H21.8726",
    stroke: "#00A862",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95328 21.6436H6.71559C7.20057 21.6436 7.66902 21.8198 8.03376 22.1394L11.8732 25.5042C12.238 25.8238 12.7064 26.0001 13.1914 26.0001H22.5482C23.0312 26.0001 23.4978 25.8253 23.862 25.5081L25.032 24.4888",
    stroke: "#00A862",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4949 14.1724H24.9968C26.1035 14.1724 26.9994 15.0714 26.9994 16.1787V16.2481C26.9994 17.3553 26.1035 18.2529 24.9968 18.2529H21.4949",
    stroke: "#00A862",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4949 18.2534H24.9968C26.1035 18.2534 26.9994 19.1525 26.9994 20.2597V20.3291C26.9994 21.4364 26.1035 22.3339 24.9968 22.3339H21.4949",
    stroke: "#00A862",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodwork);
export default __webpack_public_path__ + "static/media/goodwork.b7444d19571d6f31b6f458ac51a3e985.svg";
export { ForwardRef as ReactComponent };